
// import HomeView from "@/pages/HomeView.vue";
// import About from "@/pages/AboutView.vue";
import HTTP401 from "@/pages/HTTP401.vue";
import LoginView from "@/pages/LoginView.vue";

import OpenGPXView from "@/pages/OpenGPXView.vue";
import ClientReceiveFiles from "@/pages/ClientReceiveFiles.vue";

import MapView from "@/pages/MapView.vue";
import NewsPage from "@/pages/NewsPage.vue";
import DevelView from "@/pages/DevelView.vue";
import TestsView from "@/pages/TestsView.vue";
import DataView from "@/pages/DataView.vue";
import DumpView from "@/pages/DumpView.vue";
import HistoryView from "@/pages/HistoryView.vue";
import TransferLogView from "@/pages/TransferLogView.vue";
import OfflineDataView from "@/pages/OfflineDataView.vue";
import InfoView from "@/pages/InfoView.vue";
import JournalView from "@/pages/JournalView.vue";
import LuresView from "@/pages/LuresView.vue";
import MediaView from "@/pages/MediaView.vue";
import SystemView from "@/pages/SystemView.vue";
import DocsView from "@/pages/DocsView.vue";
import LinksView from "@/pages/LinksView.vue";
import SettingsView from "@/pages/SettingsView.vue";
import UserView from "@/pages/UserView.vue";
import TotalResetView from "@/pages/TotalResetView.vue"
import FeaturePad from "@/pages/components/FeaturePad.vue"
// import NewFeature from "@/reports/NewFeature.vue"

import DefaultLayout from "@/layouts/default/DefaultLayout.vue"



const routes = [
  {
    path: "/",
    name: "root",
    redirect: { name: "map" },
    meta: {
      title: "Root",
      icon: null,
      auth: {
        open: true
      },
    }
  },
  {
    path: "/401/",
    name: "401",
    component: HTTP401,
    meta: {
      title: "denied",
      icon: "denied",
      auth: {
        user_logged: false
      },
    }
  },

  {
    path: "/news/",
    name: "news",
    component: NewsPage,
    meta: {
      title: "Novità",
      icon: "newspaper",
      layout: DefaultLayout,
      auth: {
        user_logged: true
      },
    }
  },

  {
    path: "/login/",
    name: "login",
    component: LoginView,
    meta: {
      title: "Login",
      icon: "user",
      layout: DefaultLayout,
      auth: {
        open: true
      },
    }
  },  
  {

    // can this receive the event from the service worker?

    path: "/client-receive-shared-files",
    name: "client-receive-shared-files",
    component: ClientReceiveFiles,
    meta: {
      title: "Client receive-shared files",
      icon: "files",
      layout: DefaultLayout,
      auth: {
        user_logged: true
      },
    }
  },
  {
    path: "/Open-gpx",
    name: "Open-gpx",
    component: OpenGPXView,
    meta: {
      title: "Open GPX",
      icon: "vector-polyline",
      layout: DefaultLayout,
      auth: {
        user_logged: true
      },
    }
  },

  {
    path: "/devel/",
    name: "devel",
    component: DevelView,
    meta: {
      title: "Sviluppo",
      icon: "flask",
      layout: DefaultLayout,
      auth: {
        user_flag: "is_superuser"
      },
    }
  },
  {
    path: "/runtime-tests/",
    name: "runtimeTests",
    component: TestsView,
    meta: {
      title: "Tests",
      icon: "test-tube",
      layout: DefaultLayout,
      auth: {
        user_flag: "is_superuser"
      },
    }
  },
  {
    path: "/data/",
    name: "data",
    component: DataView,
    meta: {
      title: "Trasferimento",
      icon: "upload",
      layout: DefaultLayout,
      auth: {
        user_logged: true
      },
    }
  },
  {
    path: "/dump_restore/",
    name: "dump_restore",
    component: DumpView,
    meta: {
      title: "Dump Restore",
      icon: "swap-vertical",
      layout: DefaultLayout,
      // auth: {
      //   open: true
      // },
      auth: {
        user_flag: "is_staff"
      },
    }
  },
  {
    path: "/data/history/",
    name: "history",
    component: HistoryView,
    meta: {
      title: "Storico",
      icon: "history",
      layout: DefaultLayout,
      auth: {
        user_logged: true
      },
    }
  },
  {
    path: "/data/transferlog/",
    name: "transferlog",
    component: TransferLogView,
    meta: {
      title: "Log",
      icon: "note-text",
      layout: DefaultLayout,
      auth: {
        user_logged: true
      },
    }
  },
  

  {
    path: "/system/",
    name: "system",
    component: SystemView,
    meta: {
      title: "Sistema",
      icon: "gauge",
      layout: DefaultLayout,
      auth: {
        user_logged: true
      },
    }
  },
  {
    path: "/offline_packages/",
    name: "offline_packages",
    component: OfflineDataView,
    meta: {
      title: " Pacchetti",
      icon: "package",
      layout: DefaultLayout,
      auth: {
        user_logged: true
      },
    }
  },
  {
    path: "/info/",
    name: "info",
    component: InfoView,
    meta: {
      title: "Informazioni",
      icon: "information-outline",
      layout: DefaultLayout,
      auth: {
        user_logged: true
      },
    }
  },
  {
    path: "/map/",
    name: "map",
    component: MapView,
    meta: {
      title: "Mappa",
      icon: "map",
      layout: DefaultLayout,
      auth: {
        user_logged: true
      },
    },
    children: [
      {
        path: "/map/feature/view/",
        name: "tracker-feature-view",
        component: FeaturePad,
      },
      {
        path: "/map/feature/edit/",
        name: "tracker-feature-edit",
        back: false,
        component: FeaturePad,
      },

    ]
  },
  {
    path: "/journal/",
    name: "journal",
    component: JournalView,
    meta: {
      title: "Diario",
      icon: "notebook",
      layout: DefaultLayout,
      auth: {
        user_logged: true
      },
    }
  },
  {
    path: "/lures/",
    name: "lures",
    component: LuresView,
    meta: {
      title: "Richiami",
      icon: "bird",
      layout: DefaultLayout,
      auth: {
        user_logged: true
      },
    }
  },

  {
    path: "/media/",
    name: "media",
    component: MediaView,
    meta: {
      title: " Files",
      icon: "file-multiple",
      layout: DefaultLayout,
      auth: {
        user_logged: true
      },
    }
  },
  {
    path: "/manual/",
    name: "manual",
    component: DocsView,
    meta: {
      title: "Manuale",
      icon: "book",
      layout: DefaultLayout,
      auth: {
        user_logged: true
      },
    }
  },
  {
    path: "/links/",
    name: "links",
    component: LinksView,
    meta: {
      title: "Links",
      icon: "link",
      layout: DefaultLayout,
      auth: {
        user_logged: true
      },
    }
  },
  {
    path: "/settings/",
    name: "settings",
    component: SettingsView,
    meta: {
      title: "Impostazioni",
      icon: "cog",
      layout: DefaultLayout,
      auth: {
        user_logged: true
      },
    }
  },
  {
    path: "/account/",
    name: "account",
    component: UserView,
    meta: {
      title: "Account",
      icon: "account",
      layout: DefaultLayout,
      auth: {
        user_logged: true
      },
    }
  },
  {
    path: "/total_reset/",
    name: "total_reset",
    component: TotalResetView,
    meta: {
      title: "Reset totale",
      icon: "nuke",
      layout: DefaultLayout,
      auth: {
        open: true
      },
    }
  },
];



export default routes
